interface OrganizeEmptyStateReadiness {
  docServerConfirmed: boolean;
  folderServerConfirmed: boolean;
  isCloudWorkspace: boolean;
  isLoading: boolean;
}

/**
 * An empty cloud projection is meaningful only after both server-backed
 * metadata owners have completed. Local workspaces keep using FolderTree's
 * own hydration boundary.
 */
export function isOrganizeEmptyStateReady({
  docServerConfirmed,
  folderServerConfirmed,
  isCloudWorkspace,
  isLoading,
}: OrganizeEmptyStateReadiness): boolean {
  return isCloudWorkspace
    ? !isLoading && folderServerConfirmed && docServerConfirmed
    : !isLoading;
}
